module.exports = __webpack_public_path__ + "download-appstore.64349c9f68689d76da3780ae02911859.svg";